import { useCallback, useMemo } from 'react';
import { useAuthentication } from '../../app-store/authentication/useAuthentication';

export default function useShopLanguages() {
    const {
        spoc: { shopLanguages }
    } = useAuthentication();

    const mappedShopLanguages = useMemo(
        () =>
            [...shopLanguages]
                .sort((a, b) => a.sortIndex - b.sortIndex)
                .map(({ shopLanguageId, shopLanguageName }) => ({ shopLanguageId, shopLanguageName })),
        [shopLanguages]
    );

    const mapShopLanguageIdByLanguageName = useCallback(
        (languageName: string | undefined): string | undefined => {
            if (!languageName) {
                return undefined;
            }

            return shopLanguages.find(
                shopLanguage => shopLanguage.shopLanguageName.toLowerCase() === languageName.toLowerCase()
            )?.shopLanguageId;
        },
        [shopLanguages]
    );

    const showLote = mappedShopLanguages.length === 1 && mappedShopLanguages[0].shopLanguageId === 'en';

    return {
        shopLanguages: mappedShopLanguages,
        mapShopLanguageIdByLanguageName,
        showLote
    };
}
